import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {useGetKeyFromActiveVideoItem} from '@Hooks/poster-editor/useGetKeyFromActiveVideoItem';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {VideoItem} from '@PosterWhiteboard/items/video-item/video-item.class';
import type {SlideshowItem} from '@PosterWhiteboard/items/slideshow-item/slideshow-item.class';

interface VideoItemSpeedOptionProps {
  className?: string;
}

export function VideoItemSpeedOption({className = ''}: VideoItemSpeedOptionProps): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? (window.posterEditor?.whiteboard?.getItemForId(activeItemId) as VideoItem | SlideshowItem) : undefined;
  const speed = useGetKeyFromActiveVideoItem('speed');

  if (!activeItem || speed === undefined) {
    return null;
  }

  if (!activeItem.isVideo()) {
    return null;
  }

  const updateVideoItemSpeed = async (speedValue: number, undoable: boolean): Promise<void> => {
    await activeItem.updateFromObject(
      {
        speed: speedValue,
      },
      {
        undoable,
      }
    );
  };

  const onSpeedEndHandler = async (val: number): Promise<void> => {
    await activeItem.updateFromObject(
      {
        speed: val,
      },
      {
        undoable: true,
        checkForDurationUpdate: true,
      }
    );
  };

  const getSpeedControlSlider = (): ReactElement<any> => {
    return (
      <ContextualMenuSliderOptions
        id="video-speed-option"
        className={className}
        range={{
          min: 0.5,
          max: 2,
        }}
        transformDisplay={{
          min: 0.5,
          max: 2,
        }}
        step={0.25}
        value={speed}
        label={window.i18next.t('pmwjs_speed')}
        onChange={(val: number): void => {
          void updateVideoItemSpeed(val, false);
        }}
        onChangeEnded={(val: number): void => {
          void onSpeedEndHandler(val);
        }}
      />
    );
  };

  return getSpeedControlSlider();
}
